<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row :gutter="20">
                <el-col :md="10" :lg="4">
                    <el-input placeholder="id" size="small" v-model="params.live_id"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="5">
                    <el-select size="small" v-model="params.anchor_name" filterable placeholder="请选择主播" remote :remote-method="getAnchorList" @change="handleAnchorChange">
                        <el-option
                                v-for="item in anchorList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div v-show="false">
                        <el-col ><el-input v-model="params.anchor_id" placeholder=""></el-input></el-col>
                    </div>
                    <!--<el-input placeholder="主播id" size="small" v-model="params.anchor_id"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>-->
                </el-col>
                <el-col :md="10" :lg="5">
                    <el-select size="small" v-model="params.distributor_name" filterable placeholder="请选择店铺" remote :remote-method="getDistributorList" @change="handleDistibutorChange">
                        <el-option
                                v-for="item in distributorList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div v-show="false">
                        <el-col ><el-input v-model="params.inca_id" placeholder=""></el-input></el-col>
                    </div>
                </el-col>
                <el-col :md="10" :lg="7">
                    <el-input placeholder="直播标题" size="small" v-model="params.title"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :md="10" :lg="7">
                    <el-input placeholder="直播商品" size="small" v-model="params.item_bn"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="5" v-if="false">
                    <el-select size="small" v-model="params.is_record" clearable placeholder="是否录播" @change="search">
                        <el-option v-for="item in isRecordOption" :key="item.value" :label="item.title" size="mini" :value="item.value"> </el-option>
                    </el-select>
                </el-col>
                <el-col :md="10" :lg="4">
                    <el-select size="small" v-model="params.status" clearable placeholder="请选择直播状态" @change="search">
                        <el-option v-for="item in statusOption" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
                    </el-select>
                </el-col>
                <el-col :md="8" :lg="4">
                    <el-select size="small" v-model="params.source_video_type" clearable placeholder="请选择视频类型" @change="search">
                        <el-option v-for="item in sourceVideoTypeOption" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
                    </el-select>
                </el-col>
                <el-col :md="8" :lg="4">
                    <el-select size="small" v-model="params.type" clearable placeholder="请选择直播分类类型" @change="typesearch">
                        <el-option v-for="item in type" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
                    </el-select>
                </el-col>
                <el-col :md="8" :lg="4">
                    <el-select size="small" v-model="params.cate_id" clearable placeholder="请选择直播分类" @change="search">
                        <el-option v-for="item in category" :key="item.value" :label="item.cate_name" size="mini" :value="item.cate_id"> </el-option>
                    </el-select>
                </el-col>

            </el-row>
            <el-row :gutter="20">
                <el-col :md="10" :lg="8">
                    <el-date-picker v-model="start_at" type="daterange" start-placeholder="视频开始时间" ange-separator="至" end-placeholder="视频结束时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
                </el-col>
                <el-col :md="10" :lg="8">
                    <el-date-picker v-model="upload_at" type="daterange" start-placeholder="上传时间" ange-separator="至" end-placeholder="上传时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="updateDateChange" size="mini"></el-date-picker>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-button-group>
                        <el-button type="primary" size="small" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
                    </el-button-group>

                    <el-button-group>
                        <el-button type="primary" size="small" icon="plus" @click="exportTitle">导出标题</el-button>
                    </el-button-group>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.name" :name="item.activeName">
                    <el-table :data="ItemsList" style="width: 100%" @selection-change="handleSelectionChange"  v-loading="loading">
                        <el-table-column type="selection" align="center" label="全选"></el-table-column>
                        <el-table-column label="操作" width="100" fixed>
                            <template slot-scope="scope">
                                <el-button type="text" @click="editItemsAction(scope.$index, scope.row, false)" class="btn-gap">编辑</el-button>
                                <el-popover
                                        placement="right"
                                        width="250"
                                        trigger="hover">
                                    <div class="operating-icons">
                                        <el-button type="text" @click="deleteItemsAction(scope.$index, scope.row)" class="btn-gap">删除</el-button>
                                        <el-button type="text" @click="selectCount(scope.$index, scope.row)" class="btn-gap">查看统计报表</el-button>
                                        <el-button type="text" @click="editCount(scope.$index, scope.row)" class="btn-gap">查看操作记录</el-button>
                                        <el-button type="text" @click="exportData(scope.$index, scope.row.live_id)"  class="btn-gap">导出报表</el-button>
                                        <el-button type="text" @click="handleGetPushUrl(scope.row)" class="btn-gap" v-if="scope.row.status == 3">查看推流地址</el-button>
                                    </div>
                                    <el-button type="text" slot="reference"><i class="iconfont icon-angle-double-right"></i></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="live_id" label="直播ID" width="70"></el-table-column>
                        <el-table-column prop="sort" label="排序" width="90" show-overflow-tooltip >
                             <template slot-scope="scope">
                                <el-input v-model="scope.row.sort" @change="editItemsSort(scope.$index, scope.row)" size="mini"></el-input>
                              </template>
                        </el-table-column>
                        <el-table-column  prop="edit_status" label="状态" width="50">
                            <template slot-scope="scope">
                                <el-button type="text" v-if="scope.row.edit_status == '1'" @click="shelf(scope.$index, scope.row,2)" class="btn-gap" >下架</el-button>
                                <el-button type="text" v-if="scope.row.edit_status == '2'" @click="shelf(scope.$index, scope.row,1)" class="btn-gap" >上架</el-button>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column  prop="edit_status" label="状态" width="70">
                            <template slot-scope="scope">
                                <el-button type="text" v-if="scope.row.video_rules_status == '1'" @click="shelfRule(scope.$index, scope.row,3)" class="btn-gap" >下架规则</el-button>
                                <el-button type="text" v-if="scope.row.video_rules_status == '3'" @click="shelfRule(scope.$index, scope.row,1)" class="btn-gap" >恢复规则</el-button>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="cate_id" label="分类" width="130" show-overflow-tooltip >
                            <template slot-scope="scope">
                                <el-select size="small" v-model="scope.row.cate_id" v-if="scope.row.cate_id==item.cate_id" clearable placeholder="请选择直播分类" @change="quickEdit(scope.$index, scope.row)">
                                    <el-option v-for="item in category"  selected  :key="item.value" :label="item.cate_name" size="mini"  :value="item.cate_id"> </el-option>

                                </el-select>
                                <el-select size="small" v-model="scope.row.cate_id" v-else clearable placeholder="请选择直播分类" @change="quickEdit(scope.$index, scope.row)">
                                    <el-option v-for="item in category" :key="item.value" :label="item.cate_name" size="mini"  :value="item.cate_id"> </el-option>
                                </el-select>
                            <!-- <template slot-scope="scope" style="white-space: nowrap">{{scope.row.cate.cate_name}}</template> -->
                            </template>
                        </el-table-column>
                         <el-table-column prop="speaker" label="主讲人" width="90" show-overflow-tooltip >
                            <template slot-scope="scope" style="white-space: nowrap">{{scope.row.speaker}}</template>
                        </el-table-column>
                        <el-table-column prop="speaker" label="是否置顶" width="90" show-overflow-tooltip >
                            <template slot-scope="scope">
                                  <el-switch v-model="scope.row.is_top"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchAuth(scope.$index, scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="anchor_id" label="主播" width="90" >
                            <template slot-scope="scope" style="white-space: nowrap">
                                <router-link :to="{ path: matchInternalRoute('anchorlist'), query: {anchor_id: scope.row.anchor_id}}" class="btn-gap">{{scope.row.anchor.nickname}}</router-link>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="inca_id" label="店铺名称" width="90" show-overflow-tooltip >
                            <template slot-scope="scope" style="white-space: nowrap">{{scope.row.distributor.name}}</template>
                        </el-table-column> -->
                        <el-table-column prop="title" label="直播标题" width="90" ></el-table-column>
                        <!-- <el-table-column prop="description" label="直播简介" width="90" show-overflow-tooltip ></el-table-column> -->
                        <el-table-column prop="item_bn" label="直播商品" width="90" >
                            <template slot-scope="scope">
                                <el-button type="text" @click="handleDialogGoods(scope.row,scope.row.live_id)">查看商品</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_record" label="是否录播" width="90" v-if="false">
                            <!--<template slot-scope="scope">-->
                            <!--<el-tag size="mini" effect="plain" type="success" v-for="(v,k) in isRecordOption" :key="index" v-if="scope.row.is_record==v.value">{{v.title}}</el-tag>-->
                            <!--</template>-->
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.is_record"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchRecord(scope.$index, scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="status" label="直播状态" width="90" >
                            <template slot-scope="scope">
                            <el-tag size="mini" effect="plain" type="success" v-for="(v,k) in statusOption" :key="index" v-if="scope.row.status==v.value">{{v.name}}</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="cover_image" label="直播封面" width="100"  >
                            <template slot-scope="scope">
                                <el-popover
                                        placement="right"
                                        width="240"
                                        trigger="hover" >
                                    <img  :src="scope.row.cover_image" style="width:100%;">
                                    <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="source_video_type" label="视频类型" width="90" >
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-for="(v,k) in sourceVideoTypeOption" :key="index" v-if="scope.row.source_video_type===v.value">{{v.name}}</el-tag>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="source_video_url" label="视频回放地址" width="110" show-overflow-tooltip></el-table-column> -->
                        <!-- <el-table-column prop="start_at" label="视频开始时间" width="160" align="center"><template slot-scope="scope">{{scope.row.start_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template></el-table-column> -->
                        <!-- <el-table-column prop="end_at" label="视频结束时间" width="160" align="center"><template slot-scope="scope" v-if="scope.row.end_at!=0">{{scope.row.end_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template></el-table-column> -->
                        <el-table-column prop="upload_at" label="上传时间" width="160" align="center"><template slot-scope="scope" v-if="scope.row.upload_at!=0">{{scope.row.upload_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template></el-table-column>
                        <el-table-column prop="status" label="审核状态">
                            <template slot-scope="scope">

                                <el-tag type="primary" v-if="scope.row.video_rules_status == 0 && scope.row.video_rules != ''">待处理</el-tag>
                                <el-tag type="danger" v-else-if="scope.row.video_rules_status == 1">已通过</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.video_rules_status == 2">已拒绝</el-tag>
                                <el-tag type="warning" v-else-if="scope.row.video_rules_status == 3">已下架</el-tag>
                                <el-tag type="primary" v-else>无规则</el-tag>
                            </template>
                          </el-table-column>
                        <el-table-column label="规则审核" width="240">
                            <template slot-scope="scope">
                              <el-button size="mini" type="info" v-if="scope.row.video_rules_status == 2" v-popover:popover>
                                <el-popover ref="popover" placement="top" width="400" trigger="click">
                                  <el-input type="textarea" :rows="6" :disabled="true" :value="scope.row.video_rules_reason"> </el-input>
                                </el-popover>
                                拒绝原因
                              </el-button>
                              <div v-if="scope.row.video_rules!=''  ">
                                    <el-button size="mini" type="primary" v-if="scope.row.video_rules_status == 0" :title="scope.row.title_rules" @click="dialogOpen(scope.row.live_id)">通过</el-button>
                                    <el-button size="mini" type="primary" v-if="scope.row.video_rules_status == 0" :title="scope.row.title_rules" @click="dialogCancel(scope.row.live_id)">拒绝</el-button>
                              </div>

                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="content-center content-top-padded">
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                :current-page.sync="params.page"
                                :page-sizes="[10,20,50]"
                                :total="total_count"
                                :page-size="params.pageSize">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <router-view></router-view>
        <el-dialog :title="goodsDialog.goodsTitle" :visible.sync="goodsDialog.goodsVisible"  :before-close="handleGoodsDialogCancel">
            <el-row
                    title="商品列表"
                    type="info"
                    description=""
                    show-icon>
            </el-row>
            <el-row :gutter="10" v-loading="goodsDialog.dialogLoading">
                <el-col :md="23">
                    <el-table ref="multipleTable" :data="goodsList" style="width: 100%" tooltip-effect="dark">
                        <!--<el-table-column type="selection" width="55" > </el-table-column>-->
                        <el-table-column prop="item_id" label="商品id" v-if="false"></el-table-column>
                        <el-table-column prop="item_name" label="商品名称" width="100">
                            <template slot-scope="scope">
                                <router-link :to="{ path: matchInternalRoute('goodsphysical_editor')+ '/' + scope.row.item_id}" class="btn-gap">{{scope.row.item_name}}</router-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="item_bn" label="商品编号">
                            <template slot-scope="scope" style="white-space: nowrap"><div v-show="false">商品id:{{scope.row.item_id}}</div>{{scope.row.item_bn}}</template>
                        </el-table-column>
                        <el-table-column prop="item_bn" label="商品来源">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.item_from=='store'">店铺</el-tag>
                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.item_from=='shop'">商城</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="brief" label="商品简介" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="price" label="销售价格"></el-table-column>
                        <el-table-column prop="market_price" label="市场价格"></el-table-column>
                        <el-table-column prop="is_record" label="商品图片" width="90" >
                            <template slot-scope="scope">
                                <el-popover
                                        placement="right"
                                        width="240"
                                        trigger="hover" >
                                    <div style="overflow-y: scroll;overflow-x: hidden;height:240px;text-align:center;">
                                        <img  :src="v" class="goods-popover-img" style="width:92%;" v-for="v in scope.row.pics">
                                    </div>
                                    <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="100">
                            <template slot-scope="scope">
                                <el-button type="text" @click="deleteGoodsAction(scope.$index, scope.row,)" class="btn-gap">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="content-center content-top-padded" v-show="false">
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleGoodsDialogCurrentChange"
                                @size-change="handleGoodsDialogSizeChange"
                                :current-page.sync="goodsDialog.goodsParams.page"
                                :page-sizes="[100,200,300]"
                                :total="goodsList.total_count"
                                :page-size="goodsDialog.goodsParams.pageSize">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer position-left">
              <el-button @click="goodsDialog.goodsVisible = false">取 消</el-button>
              <el-button type="primary" @click="goodsDialog.goodsVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="拒绝提现" :visible.sync="canceldialog" :close-on-click-modal="false" width="50%">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入拒绝原因"
            v-model="video_rules_reason">
          </el-input>
          <div slot="footer" class="dialog-footer content-center">
            <el-button @click.native="canceldialog = false;">取消操作</el-button>
            <el-button type="primary" @click="actionProcessCashWithdrawal(2)">确认拒绝</el-button>
          </div>
        </el-dialog>
        <sideBar :visible.sync="show_sideBar" title="统计报表" width="40">
            <el-table  :data="liveLog" style="width: 100%" tooltip-effect="dark">
                <el-table-column prop="user_id" label="用户id"></el-table-column>
                <el-table-column prop="user_ip" label="用户ip"></el-table-column>
                <el-table-column prop="created_at" label="首次登录时间">
                    <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
                </el-table-column>
                <el-table-column prop="userinfo.username" label="用户昵称"></el-table-column>
                <el-table-column  label="观看时长">
                    <template slot-scope="scope">
                        <span>{{scope.row.time.day}}天{{scope.row.time.hour}}时{{scope.row.time.min}}分{{scope.row.time.sec}}秒</span>
                    </template>
                </el-table-column>
                <!--<el-table-column  label="是否评论">-->
                     <!--<template slot-scope="scope">-->
                        <!--<span v-if="scope.row.is_comment==1">是</span>-->
                        <!--<span v-else>否</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column prop="comment_count" label="评论个数"></el-table-column>-->
            </el-table>
        </sideBar>
        <sideBar :visible.sync="show_edit" title="操作记录" width="40">
            <el-table  :data="LiveOperationLog" style="width: 100%" tooltip-effect="dark">
                <el-table-column prop="admin" label="操作员"></el-table-column>
                <el-table-column prop="ip" label="操作员ip"></el-table-column>
                <el-table-column prop="created_at" label="操作时间">
                    <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
                </el-table-column>
                <el-table-column  label="操作内容">
                    <template slot-scope="scope">
                        <span>{{scope.row.operation_content}}</span>
                    </template>
                </el-table-column>

            </el-table>
        </sideBar>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { getDistributorList } from '../../api/marketing'
    import {
        saveSortLive,
        saveShelfRule,
        getLiveList as getList,
        updateLiveStatus as updateStatus,
        deleteLive as deleteItem,
        getLiveGoods as getLiveGoods,
        deleteLiveGoods as deleteLiveGoods,
        getAnchorList as getAnchorList,
        getPushUrl as getPushUrl,
        getLiveConf,
        BatchDeleteLive,
        getCateList,
        getLiveLog,
        getLiveOperationLog,
        VideoRulesStatus,
        getLiveExport,
        getLiveExportTitle
    } from '../../api/live'
    import sideBar from '@/components/element/sideBar'
    export default {
        components: {
          sideBar
        },
        props: {
          distributorId: {
            type: String,
            default: ''
          },
          isLoad: {
            type: Boolean,
            default: false
          }
        },
        data () {
            return {
                status:'',
                loading:true,
                exportloading: false,
                tabList: [
                    {name: "列表", value: null, activeName: 'first'},
                    {name: "待审核", value: 'true', activeName: 'second'},
                ],
                activeName: 'first',
                ItemsList: [],
                params: {
                    page: 1,
                    pageSize: 20,
                    live_id:'',
                    anchor_id:'',
                    anchor_name:'',
                    inca_id:'',
                    title:'',
                    description:'',
                    cover_image:'',
                    item_bn:'',
                    is_record:'',
                    source_video_type:'',
                    cate_id:'',
                    source_video_url:'',
                    start_at:'',
                    end_at:'',
                    type:'',
                    start_upload_at:'',
                    end_upload_at:'',
                    video_rules_status:-1
                },
                start_at:'',
                end_at:'',
                upload_at:'',
                total_count:0,
                isRecordOption: [
                    { title: '允许', value: '1' },
                    { title: '不允许', value: '0' },
                ],
                videoTypeOption: [
                    // { title: '直播', value: 'live' },
                    // { title: '回放', value: 'record' },
                    // { title: '上传视频', value: 'upload' },
                ],
                sourceVideoTypeOption:[],
                category:[],
                type:[
                    { name: '普通视频', value: 1 },
                    { name: '短视频', value: 2 },
                ],
                liveLog:[],
                LiveOperationLog:[],
                statusOption: [
                    { name: '未开始', value: 0 },
                    { name: '直播中', value: 1 },
                    { name: '已结束', value: 2 },
                    { name: '预告', value: 3 },
                ],
                distributorList:[],
                anchorList:[],
                goodsDialog:{
                    dialogLoading:true,
                    goodsTitle:'',
                    goodsVisible:false,
                    goodsParams:{
                        page:1,
                        pageSize:20,
                    },
                },
                goodsList:[],
                rowData:[],
                item_id:[],
                // dialog: false,
                canceldialog: false,
                video_rules_reason:'',
                detail: '',
                show_sideBar: false,
                show_edit: false
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            exportData (index, item) {
                this.exportloading = true
                this.params.export = 1
                this.params.live_id = item
                // console.log(this.params);
                getLiveExport(this.params).then(res => {
                    this.exportloading = false
                    if (res.data.status) {
                        this.$message({
                            type: 'success',
                            message: '已加入执行队列，请在设置-导出列表中下载'
                        })
                        return
                    }else {
                        this.$message({
                            type: 'error',
                            message: '无内容可导出 或 执行失败，请检查重试'
                        })
                        return
                    }
                }).catch( error => {
                    this.exportloading = false
                })
            },
            exportTitle () {
                this.exportloading = true
                getLiveExportTitle(this.params).then(res => {
                    this.exportloading = false
                    if (res.data.status) {
                        this.$message({
                            type: 'success',
                            message: '已加入执行队列，请在设置-导出列表中下载'
                        })
                        return
                    }else {
                        this.$message({
                            type: 'error',
                            message: '无内容可导出 或 执行失败，请检查重试'
                        })
                        return
                    }
                }).catch( error => {
                    this.exportloading = false
                })
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            selectCount(index, row)
            {
                this.show_sideBar = true
                getLiveLog({live_id:row.live_id}).then(res => {
                    this.liveLog = res.data.data.list
                })
            },
            editCount(index, row)
            {
                this.show_edit = true
                getLiveOperationLog({live_id:row.live_id}).then(res => {
                    this.LiveOperationLog = res.data.data.list
                })
            },
            handleSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            handleClick (tab, event) {
                this.params.page = 1
                if(this.activeName == 'second') {
                    this.params.video_rules_status = 0
                }else{
                    this.params.video_rules_status = -1
                }
                this.getList()
            },
            handleSelectionChange (val) {
                let item_id = []
                for (let i in val) {
                    item_id.push(val[i].live_id)
                }
                this.item_id = item_id
            },
            batchDelete(){
                this.$confirm('此操作将批量删除数据,删除后不可恢复， 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    BatchDeleteLive({id:this.item_id}).then(res=>{
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.search();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })

            },
            handleGoodsDialogCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            handleGoodsDialogSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            async handleDialogGoods(row,live_id) {
                this.goodsList = [];
                this.rowData = row;
                this.goodsDialog.goodsTitle = '(id:'+row.live_id + ')' + row.anchor.nickname + "-" + row.distributor.name ;
                this.goodsDialog.dialogLoading = true
                this.goodsDialog.goodsVisible = true
                this.goodsDialog.goodsParams.page = 1
                this.goodsDialog.goodsParams.pageSize = 10
                await getLiveGoods({'id':live_id}).then(res=>{
                    if(res.data.data){
                        this.goodsDialog.dialogLoading = false
                        this.goodsList = res.data.data;
                    }
                });

            },
            handleGoodsDialogCancel(){
                this.goodsDialog.goodsVisible = false
            },
            switchRecord(index, row) {
                let params = {
                    'id': row.live_id,
                    'is_record': row.is_record ,
                }
                updateStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        //this.getList()
                    }
                })
            },
            dateChange (val) {
                if (val && val.length > 0) {
                    this.params.start_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.params.end_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.params.start_at = ''
                    this.params.end_at = ''
                }
                this.search();
            },
            updateDateChange (val) {
                if (val && val.length > 0) {
                    this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.params.start_upload_at = ''
                    this.params.end_upload_at = ''
                }
                this.search();
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            addItems () { // 添加
                this.$router.push({path: this.matchHidePage('editor')})
            },
            editItemsSort (index, row) {

                saveSortLive({"sort": row.sort, "live_id": row.live_id}).then(response => {
                  this.$message({
                        message: '排序成功',
                        type: 'success',
                        duration: 2 * 1000
                    })
                  this.getList()
                })

            },
            switchAuth (index, row) {

                saveSortLive({"is_top": row.is_top, "live_id": row.live_id}).then(response => {
                  this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2 * 1000
                    })
                  this.getList()
                })

            },
            quickEdit (index, row) {
                saveSortLive({"cate_id": row.cate_id, "live_id": row.live_id}).then(response => {
                  this.$message({
                        message: '修改成功',
                        type: 'success',
                        duration: 2 * 1000
                    })
                  this.getList()
                })

            },
            shelf (index, row,status) {
                saveSortLive({"edit_status": status, "live_id": row.live_id}).then(response => {
                  this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2 * 1000
                    })
                  this.getList()
                })

            },
            shelfRule (index, row,status) {
                saveShelfRule({"video_rule_status": status, "live_id": row.live_id}).then(response => {
                  this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2 * 1000
                    })
                  this.getList()
                })

            },
            search () {
                this.params.page = 1
                this.params.video_rules_status = -1
                this.getList()
            },
            typesearch (){
                this.params.page = 1
                getCateList({page:1,pageSize:-1,type:this.params.type}).then(res=>{
                    if(res.data){
                        this.category = res.data.data.list
                    }
                })
                this.getList()
            },
            getList () {
                this.loading = true
                getList(this.params).then(response => {
                    this.ItemsList = response.data.data.list
                    this.ItemsList.forEach(item => {
                        item.price = item.price/100
                        item.link = `pages/item/espier-detail?gid=${item.goods_id}&id=${item.item_id}`

                        item.video_rules = item.video_rules ? item.video_rules : ''
                        item.title_rules = '';
                        if(item.video_rules!='')
                        {
                            var jsonstr = JSON.parse(item.video_rules)
                            if(jsonstr.money!='' && jsonstr.money!=undefined)
                            {
                                jsonstr.money.forEach(i=>{
                                    item.title_rules+='红包奖励：'+i.money_values+'人民币,人数：'+i.markrting+',观看时长：'+i.time+"s\n"
                                })
                            }
                            if(jsonstr.integral!='' && jsonstr.integral!=undefined)
                            {
                                jsonstr.integral.forEach(i=>{
                                    item.title_rules+='积分奖励：'+i.attr_values+'个积分,观看时长：'+i.time+"s\n"
                                })
                            }
                            if(jsonstr.coupon!='' && jsonstr.coupon!=undefined)
                            {
                                jsonstr.coupon.forEach(i=>{
                                    if(i.coupon_info && i.coupon_info[0].title)
                                    {
                                        item.title_rules+='优惠券奖励：'+i.coupon_info[0].title+'.优惠券,观看时长：'+i.time+"s\n"
                                    }else{
                                        item.title_rules+="脏数据，及时清理"
                                    }

                                })
                            }
                        }


                    })

                    this.total_count = response.data.data.total_count
                    this.warning_store = response.data.data.warning_store
                    this.loading = false
                })

            },
            editItemsAction (index, row, isNew) {
                // if(row.edit_status==1 && row.video_rules!='')
                // {

                //     this.$message({
                //         message: '请先下架该视频后进行编辑',
                //         type: 'error',
                //         duration: 2 * 1000
                //     })

                //     return
                // }
                // let date = new Date().getTime()/1000;
                // let edit_time = (parseInt(row.upload_at)+180)
                // if(edit_time>parseInt(date) && row.video_rules!='')
                // {
                //     this.$message({
                //         message: '请在'+(edit_time-parseInt(date))+'秒后进行编辑',
                //         type: 'error',
                //         duration: 2 * 1000
                //     })
                //     return
                // }
                if (isNew) {
                    var routeData = this.$router.push({ path: this.matchHidePage('editor/') + row.live_id, query: { is_new: true}});
                } else {
                    var routeData = this.$router.push({ path: this.matchHidePage('editor/') + row.live_id});
                }
            },
            deleteItemsAction (index, row) {
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteItem(row.live_id).then(response => {
                        this.ItemsList.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            deleteGoodsAction (index, row) {
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteLiveGoods({goods_id:row.item_id,live_id:this.rowData.live_id}).then(response => {
                        this.ItemsList.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            updateItemStatus (items,status) {
                this.loading = true
                let params = {}
                params = {
                    'id': items.anchor_id,
                    'status': status,
                }
                updateStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.getList()
                    }
                })
                this.loading = false
            },
            getDistributorList(val){
                getDistributorList({page: 1, pageSize: 50,name:val}).then(res => {
                    this.distributorList = [{name:'请选择店铺',id:''}];
                    for (let item of res.data.data.list) {
                        this.distributorList.push({name: item.name, id: item.number})
                    }
                    // console.log( this.distributorList);
                })
            },
            handleDistibutorChange:function (val){
                this.params.inca_id = val
                this.getList()
            },
            getAnchorList(val){
                getAnchorList({page: 1, pageSize: 50,nickname:val}).then(res => {
                    this.anchorList = [{name:'请选择主播',id:''}];
                    for (let item of res.data.data.list) {
                        this.anchorList.push({name: item.nickname, id: item.anchor_id})
                    }
                })
            },
            handleAnchorChange:function (val){
                this.params.anchor_id = val
                this.getList()
            },
            handleGetPushUrl(row){
                let params = {
                    'id': row.anchor_id,
                    'live_id':row.live_id,
                }
                getPushUrl(params).then(res => {
                    if (res.data) {
                        const h = this.$createElement;
                        this.$message({
                            message: h('p', null, [
                                h('span', null, '推流地址： '),
                                h('p', { style: 'color: blue;padding-right:25px;' }, res.data.data.push_url)
                            ]),
                            showClose: true,
                            duration: 10 * 1000,
                        });
                    }
                })
            },
            // 通过
            dialogOpen (detail) {
                this.detail = detail
                var params = {video_rules_status: 1}
                VideoRulesStatus(this.detail,params).then(response => {
                    this.$message({ type: 'success', message: '审核通过'})
                    this.getList()

                })
            },
            // 拒绝
            dialogCancel (detail) {
                this.canceldialog = true
                this.detail = detail
            },
            // 拒绝原因
            actionProcessCashWithdrawal (processType) {
                if(processType == 2 && !this.video_rules_reason) {
                  this.$message({ type: 'error', message: '请输入审核驳回原因' })
                  return
                }

                if(processType == 2) {
                  var params = {video_rules_status: processType, video_rules_reason: this.video_rules_reason}
                } else {
                  var params = {video_rules_status: processType}
                }
                VideoRulesStatus(this.detail, params).then(response => {

                  this.canceldialog = false
                  if(processType == 2) {
                    this.$message({ type: 'success', message: '审核驳回' })
                  } else {
                    this.$message({ type: 'success', message: '通过' })
                  }
                  this.getList()
                })
              },

        },
        mounted () {
            getLiveConf().then(res=>{

                if(res.data){
                    this.sourceVideoTypeOption = res.data.source_video_type
                }
            })
            getCateList({page:1,pageSize:-1,type:this.params.type}).then(res=>{
                if(res.data){
                    this.category = res.data.data.list
                }
            })
            this.params = this.$route.query
            this.getList()
            this.getDistributorList()
            this.getAnchorList()
        },
        watch: {
            getStatus (val) {
                if (val) {
                    this.getList()
                }
            },
            $route(){
                this.getList()
            }
        }
    }

</script>
<style>
    .goods-popover-img{
        margin-top: 5px;
        margin-bottom: 5px;
        background:#000;
        border:1px solid #fff;
        border-width:5px 5px 5px 5px;
        box-shadow:1px 1px 5px #333;
        -webkit-box-shadow:1px 1px 5px #333;
        -moz-box-shadow:1px 1px 5px #333;
    }
</style>



// WEBPACK FOOTER //
// list.vue?505b909f